import last from 'lodash/last';
import { Job, Vehicle } from 'models';

export const containsDrivers = (job: Job, driverList: (number | string)[]): boolean => {
    const dispatches = job.dispatches!.items.filter((it) => it.vehicle != null);
    const vehicleId = last(dispatches.map((it) => it.vehicle!.id)) || 0;
    return driverList.length ? dispatches.length > 0 && driverList.includes(vehicleId) : true;
};

export const vehicleContainsDrivers = (
    driverList: (number | string)[],
    vehicle: Vehicle
): boolean => {
    return driverList.length ? driverList.includes(vehicle.id!) : true;
};

export const containsPolicies = (job: Job, policyList: (number | string)[]): boolean => {
    return policyList.length ? !!job.policy && policyList.includes(job.policy.id!) : true;
};

export const containsCampaigns = (job: Job, campaignList: (number | string)[]): boolean => {
    return campaignList.length ? !!job.campaign && campaignList.includes(job.campaign.id!) : true;
};

export const jobNameContains = (job: Job, filterInput: string): boolean => {
    return job.name ? job.name.toLowerCase().includes(filterInput.toLowerCase()) : true;
};

export const jobStatusMatches = (job: Job, status?: string): boolean => {
    return status ? job.status === status : true;
};
